import React from 'react';
import {word} from "../../word.js";

const FormInput = ({item, index, setForm,} ) => {
    const handleChange = (e) => {
        setForm((prevForm) => {
            const updatedForm = [...prevForm];
            const updatedItem = { ...updatedForm[index] };

            updatedItem.value = e.target.value;
            updatedItem.valid =
                updatedItem.type === 'number'
                    ? parseInt(updatedItem.value, 10) > 0 && parseFloat(updatedItem.value, 10) === Math.floor(updatedItem.value)
                    : updatedItem.value.length > 0;

            updatedForm[index] = updatedItem;
            return updatedForm;
        });
    };

    const handleBlur = () => {
        setForm((prevForm) => {
            const updatedForm = [...prevForm];
            const updatedItem = { ...updatedForm[index] };
            updatedItem.active = true
            updatedForm[index] = updatedItem;
            return updatedForm;
        });
    };
    return (

        <div key={index} className="input-section">
            <input
                className={item.valid ? "orgInput" : "orgInput invalid-input"}
                type={item.type}
                placeholder={word[item.key]}
                value={item.value || ''}
                onChange={handleChange}
                onBlur={handleBlur}
            />
            {!item.valid && <div className="validation">{item.errorMessage}</div>}
        </div>
    )
};


export default FormInput;